import React from "react";

import { Delete } from "icons";

import { Typography, SearchBar, Button } from "clearsense-ui/components";

const FilterHeader = ({
  connectionCount,
  searchString,
  setSearchString,
  isDeleteButtonDisabled,
  openDeleteAlert,
}) => {
  const handleSearchChange = ({ target: { value } }) =>
    setSearchString(value.trim());

  return (
    <div className="flex justify-between mt-4 mb-8">
      <div className="flex items-center space-x-2 ">
        <Typography style="large" type="bold">
          {connectionCount > 0 &&
            `${connectionCount} connection${
              connectionCount > 1 ? "s" : ""
            } found`}
        </Typography>
      </div>

      <div className="flex items-center space-x-2">
        <SearchBar value={searchString} onChange={handleSearchChange} />
        <Button
          style="secondary"
          icon={Delete}
          label="Delete"
          className="font-semibold text-danger"
          onClick={openDeleteAlert}
          disabled={isDeleteButtonDisabled}
        />
      </div>
    </div>
  );
};

export default FilterHeader;
